import { memoryCache } from 'mihoyo-store';
import { CACHE_INSTANCE_ID, CACHE_USER_LIST } from '@configPath/cacheConfigs/memoryCache.config';
import customEvent from 'mihoyo-custom-event';
import { PRE_POST, TO_MYPORNS } from '@configPath/eventConfigs/customEvent.config';
import modal from '../modal';
import main from '../main';

import model from '../../models/default';
// memoryCache的存在仅仅是为了演示多个模块之间共享数据的方法，可删除相关代码
// const memoryCache = Store.getInstance();

export default {

  /**
   * 视图容器对象
   * @returns {jQuery|HTMLElement}
   */

  options() {
    return $('.form-role')
  },

  title() {
    return $('.form-title')
  },

  nickname() {
    return $('.form-nickname')
  },

  desc() {
    return $('.form-desc')
  },

  uid() {
    return $('.form-uid')
  },

  phone() {
    return $('.form-phone')
  },

  qq() {
    return $('.form-qq')
  },

  role() {
    return $('.form-role')
  },

  upload() {
    return $('.form-upload')
  },

  uploadResult() {
    return $('.form-upload-result')
  },

  submit() {
    return $('.form-submit')
  },

  upload_token:'',
  filename:'',
  /**
   * 视图渲染方法
   */
  render() {
    this.events();
  },

  paramCheck() {
    if (this.filename) {
      const title = this.title().val();
      const nickname = this.nickname().val();
      const desc = this.desc().val();
      const uid = this.uid().val();
      const mobile = this.phone().val();
      const qq = this.qq().val();
      const role = this.role().val();
      const file_list = `["${this.filename}"]`;
      return {
        title,
        nickname,
        desc,
        uid,
        mobile,
        qq,
        role,
        file_list
      };
    } else {
      return false;
    }
  },

  handleSubmit(options) {
    model.submit({data:options}).then(({left_times}) => {
      customEvent.emit(TO_MYPORNS, {});
      modal('.success-modal', `剩余次数:${left_times}`, () => {
        customEvent.emit(PRE_POST);
      }, () => {
        main.jump('.page-4', '.page-5');
      });
      $('.page-1-myporn').css('display', 'block');
    }).fail(main.handleFail);
  },

  /**
   * 视图事件集中绑定
   */
  events() {
    customEvent.on(PRE_POST, () => {
      this.options().html('');
      this.title().val('');
      this.nickname().val('');
      this.desc().val('');
      this.phone().val('');
      this.qq().val('');
      this.role().val('');
      this.upload().html('');
      this.uploadResult().html('');
      model.prePost().then(({form_info, uid, upload_token}) => {
        this.upload_token = upload_token;
        if (uid) {
          this.uid().val(uid).attr("disabled","disabled");
        }
        if (form_info.length) {
          const target = form_info.find(o => o.name === 'role');
          target ? target.option.forEach((item) => {
            this.options().append(`<option class='form-role-option' value=${item.id}>${item.name}</option>`);
          }) : null;
        }
        main.jump('.page-1', '.page-4');
      }).fail(main.handleFail);
    });
    this.upload().on('change', (e) => {
      const sendData = new FormData();
      sendData.append('file',e.target.files[0]);
      sendData.append('token',this.upload_token);
      model.upload({
        contentType: false,
        processData:false,
        data:sendData
      }).then(({url, name}) => {
        this.uploadResult().html(main.imgHandler(url, true));
        this.filename = name;
        this.upload().val('');
      }).fail(({message, retcode}) => {
        main.handleFail({message, retcode});
        this.upload().val('');
      });
    });
    this.submit().on('click', () => {
      const options = this.paramCheck();
      if (!options) {
        modal('.cancel-modal', '舰长，你还没投稿啊喂~');
      } else {
        modal('.submit-modal', `UID:${this.uid().val()}`, () => {
          this.handleSubmit(options);
        });
      }
    });
  }
}